import NavBar from './nav-bar.component';

export default NavBar;
